<template>
  <div class="col-12">
    <div class="card card-outline card-info">
      <div class="card-header">
        <h3 class="card-title">Reporte de evaluaciones por departamento</h3>
      </div>
      <div class="card-body">
        <!-- Dropdown para seleccionar especialidad -->
        <div class="mb-4 specialty-select-container">
          <label for="specialty" class="specialty-label">Seleccionar especialidad:</label>
          <select
            id="specialty"
            class="custom-select"
            v-model="selectedSpecialty"
            @change="filterUsersBySpecialty"
          >
            <option value="" disabled>Selecciona una especialidad</option>
            <option v-for="specialty in specialties" :key="specialty">
              {{ specialty || "Sin Especialidad" }}
            </option>
          </select>
        </div>

        <!-- Lista de usuarios filtrados -->
        <div v-if="filteredUsers.length" class="user-list">
          <h4 class="user-title">Usuarios:</h4>
          <div v-for="user in filteredUsers" :key="user.id" class="user-card">
            <div class="user-header">
              <strong>{{ user.name }}</strong> - {{ user.email }}
            </div>
            <table class="evaluation-table">
              <thead>
                <tr>
                  <th style="width: 40%;">Evaluaciones</th>
                  <th style="width: 30%;">Evaluación de objetivos</th>
                  <th style="width: 30%;">Plan Individual de Desarrollo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="td-baseline">
                    <span :class="getStatusClass(user.autoevaluations.length)">
                      {{ getStatusText(user.autoevaluations.length) }}
                    </span>
                    <div v-if="user.competencies.length > 0" class="details-table">
                      <table>
                        <thead>
                          <tr>
                            <th>Competencia</th>
                            <th>Autoevaluación</th>
                            <th>Jefe</th>
                            <th>Terceros</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="competency in user.competencies"
                            :key="competency.name"
                          >
                            <td>{{ competency.name }}</td>
                            <td>
                              {{ formatNumberDecimal(getCompetencyScore(user, 'autoevaluations', competency.name)) }} Pts
                              <span v-if="getCommentScore(user, competency.id, 'autoevaluation')" style="cursor: pointer;" class="ml-3 cursor-pointer" @click="openModalComment(getCommentScore(user, competency.id, 'autoevaluation'))">
                                <i class="fa-solid fa-comment"></i>
                                <!-- Comentario: {{ getCommentScore(getAutoId(competency.name), 'autoevaluation') }} -->
                              </span>
                            </td>
                            <td>
                              {{ formatNumberDecimal(getCompetencyScore(user, 'managerEvaluations', competency.name)) }} Pts
                              <span v-if="getCommentScore(user, competency.id, 'manager')" style="cursor: pointer;" class="ml-3 cursor-pointer" @click="openModalComment(getCommentScore(user, competency.id, 'manager'))">
                                <i class="fa-solid fa-comment"></i>
                                <!-- Comentario: {{ getCommentScore(getAutoId(competency.name), 'autoevaluation') }} -->
                              </span>
                            </td>
                            <td>
                              {{ formatNumberDecimal(getCompetencyScore(user, 'thirdsEvaluations', competency.name)) }} Pts
                              <span v-if="getCommentScore(user, competency.id, 'third')" style="cursor: pointer;" class="ml-3 cursor-pointer" @click="openModalComment(getCommentScore(user, competency.id, 'third'))">
                                <i class="fa-solid fa-comment"></i>
                                <!-- Comentario: {{ getCommentScore(getAutoId(competency.competency_name), 'autoevaluation') }} -->
                              </span>
                            </td>
                          </tr>

                          <tr
                          >
                            <td> Promedio </td>
                            <td>
                              {{ formatNumberDecimal(getAverageEvaluationScore(user, 'autoevaluations')) }} Pts
                              
                            </td>
                            <td>
                              {{ formatNumberDecimal(getAverageEvaluationScore(user, 'managerEvaluations')) }} Pts
                              
                            </td>
                            <td>
                              {{ formatNumberDecimal(getAverageEvaluationScore(user, 'thirdsEvaluations')) }} Pts
                              
                            </td>
                          </tr>
                          
                        </tbody>
                      </table>
                    </div>
                  </td>
                  <!-- <td class="td-baseline">
                    <span :class="getStatusClass(user.managerEvaluations.length)">
                      {{ getStatusText(user.managerEvaluations.length) }}
                    </span>
                    <div v-if="user.managerEvaluations.length > 0" class="details-table">
                      <table>
                        <thead>
                          <tr>
                            <th>Competencia</th>
                            <th>Calificación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="competency in user.managerEvaluations[0].competency_scores"
                            :key="competency.competency_name"
                          >
                            <td>{{ competency.competency_name }}</td>
                            <td>{{ competency.average_score }} Pts</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                  <td class="td-baseline">
                    <span :class="getStatusClass(user.scopeEvaluations.length)">
                      {{ getStatusText(user.scopeEvaluations.length) }}
                    </span>
                    <div v-if="user.scopeEvaluations.length > 0" class="details-table">
                      <table>
                        <thead>
                          <tr>
                            <th>Objetivo</th>
                            <th>Calificación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="competency in user.scopeEvaluations"
                            :key="competency.scope_goal_id"
                          >
                            <td>{{ competency.scope_goal_name }}</td>
                            <td>{{ competency.average_score }} %</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>                   -->
                   <td class="td-baseline">
                    <!-- @click="openPlanModal(user.autoevaluations[0].id, user.id) -->
                    <span :class="getStatusClass(user.scopeEvaluations.length)">
                      {{ getStatusText(user.scopeEvaluations.length) }}
                    </span>
                    <div v-if="user.scopeEvaluations.length > 0" class="details-table">
                     <table style="table-layout: fixed; width: 100%;">
                        <thead>
                          <tr>
                            <th style="width: 30%;" colspan="2">Objetivo</th>
                            <th style="width: 30%;">% Avanzado</th>
                          </tr>
                          <tr>
                            <th style="width: 30%;" >Meta</th>
                            <th style="width: 30%;" >% equivalencia </th>
                            <th style="width: 30%;">% Avanzado</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(competency, row) in user.scopeEvaluations" :key="row">
                            <td style="white-space: normal; word-wrap: break-word; overflow-wrap: break-word;">
                              {{ competency.scope_goal_name }}
                            </td>
                            <td style="white-space: normal; word-wrap: break-word; overflow-wrap: break-word;">
                              {{ competency.scope_goal_percentage }} %
                            </td>  
                            <td style="max-width: 250px; white-space: normal; word-wrap: break-word; overflow-wrap: break-word;">
                              {{ competency.average_score }} %
                            </td>
                          </tr>

                          <!-- <tr>
                            <td style="white-space: normal; word-wrap: break-word; overflow-wrap: break-word;">
                              Promedio
                            </td>
                            <td style="max-width: 250px; white-space: normal; word-wrap: break-word; overflow-wrap: break-word;">
                              {{ getAverageOfCompetenciesScopeUser(user) }} %
                            </td>
                          </tr>                           -->
                        </tbody>
                        <tfoot>
                          <tr>
                            <td style="white-space: normal; word-wrap: break-word; overflow-wrap: break-word;">
                              Promedio
                            </td>
                            <td style="max-width: 250px; white-space: normal; word-wrap: break-word; overflow-wrap: break-word;" colspan="2">
                              {{ getAverageGoal(user) }} %
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </td>
                  <td class="td-baseline">
                    <!-- @click="openPlanModal(user.autoevaluations[0].id, user.id) -->
                    <span :class="getStatusClass(user.plansCompetencies.length)">
                      {{ getStatusText(user.plansCompetencies.length) }}
                    </span>
                    <div v-if="user.plansCompetencies.length > 0" class="details-table">
                     <table style="table-layout: fixed; width: 100%;">
                        <thead>
                          <tr>
                            <th style="width: 30%;">Competencia</th>
                            <th style="width: 40%;">Plan</th>
                            <th style="width: 30%;">% Avanzado</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(competency, row) in user.plansCompetencies[0].competencies" :key="row">
                            <td style="white-space: normal; word-wrap: break-word; overflow-wrap: break-word;">
                              {{ competency.competency.name }}
                            </td>
                            <td style="max-width: 250px; white-space: normal; word-wrap: break-word; overflow-wrap: break-word;">
                              {{ competency.improvement_plan }}
                            </td>
                            <td style="max-width: 250px; white-space: normal; word-wrap: break-word; overflow-wrap: break-word;">
                              <p v-if="user.lastPlanCompleted.length > 0">
                                <span v-for="rowPlan in user.lastPlanCompleted[0].plan_individual_responses" :key="rowPlan.id">
                                  <b v-if="competency.competency.id === rowPlan.plan_competency.competency_id">{{ rowPlan.progress_percentage }}%</b>
                                </span>
                              </p>
                              <p v-else> N/A </p>
                            </td>
                          </tr>
                            <tr>
                              <td style="white-space: normal; word-wrap: break-word; overflow-wrap: break-word;" colspan="2">
                               Promedio 
                              </td>
                              <td style="max-width: 250px; white-space: normal; word-wrap: break-word; overflow-wrap: break-word;">
                               
                                    <b>{{ getAverageProgressFromPlans(user)}}%</b>
                              </td>
                            </tr>
                          
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-else>
          <p>No hay usuarios para la especialidad seleccionada.</p>
        </div>
      </div>
        <IndividualPlanModal
				:isModalOpen="isModalPlanOpen"
				:evaluationId="currentEvaluationId"
				:userId="userId"
				@close="closePlanModal"
				@plan-saved="fetchReports()"
				/>
    </div>
    
    <ModalComment v-if="isModalCommentOpen" :comment="comment" @close="closeModalComment" />
  </div>


</template>

<script>
import { mapMutations } from "vuex";
import request from "../../services/request";
import IndividualPlanModal from "../../component/evaluations/IndividualPlanModal.vue";
import ModalComment from "@/component/evaluations/ModalComment.vue";


export default {
  name: "report-evaluations",
  components: {
    IndividualPlanModal,
    ModalComment
	},
  data() {
    return {
      reports: [], // Datos del reporte
      specialties: [], // Lista de especialidades únicas
      selectedSpecialty: "", // Especialidad seleccionada
      filteredUsers: [],      
			isModalPlanOpen: false,
      currentEvaluationId: 0,
      userId: null,      
      loading: true,
      error: null,
      comment: null,
      isModalCommentOpen: false,
    };
  },
  async mounted() {
    this.setHeaderTitle("Auto Evaluación");
    await this.fetchReports();
    this.extractSpecialties();
  },
  methods: {
    async fetchReports() {
      try {
        const { data } = await request.list("/evaluations/report");
        this.reports = data.data;
      } catch (error) {
        console.error("Error al obtener los reportes:", error);
      }
    },
   getAutoId(user, competencyName) {
    if (!user || !Array.isArray(user.autoevaluations) || user.autoevaluations.length === 0) {
      return 0;
    }
    const evaluation = user.autoevaluations[0];
    if (!evaluation || !Array.isArray(evaluation.competency_scores)) {
      return 0;
    }
    const competency = evaluation.competency_scores.find(
      (comp) => comp.competency_name === competencyName
    );
    return competency?.competency_id || 0;
  },

  getManagerId(user, competencyName) {
    if (!user || !Array.isArray(user.averageEvaluations) || user.averageEvaluations.length === 0) {
      return 0;
    }
    const evaluation = user.averageEvaluations[0];
    if (!evaluation || !Array.isArray(evaluation.competency_scores)) {
      return 0;
    }
    const competency = evaluation.competency_scores.find(
      (comp) => comp.competency_name === competencyName
    );
    return competency?.competency_id || 0;
  },

  getThirdId(user, competencyName) {
    if (!user || !Array.isArray(user.thirdsEvaluations) || user.thirdsEvaluations.length === 0) {
      return 0;
    }
    const evaluation = user.thirdsEvaluations[0];
    if (!evaluation || !Array.isArray(evaluation.competency_scores)) {
      return 0;
    }
    const competency = evaluation.competency_scores.find(
      (comp) => comp.competency_name === competencyName
    );
    return competency?.competency_id || 0;
  },

    openModalComment(comment) {
      console.log('comment', comment);
      this.comment = comment;
      this.isModalCommentOpen = true;
    },
    closeModalComment() {
      this.isModalCommentOpen = false;
    },

    getCommentScore(user, competency_id, type = 'autoevaluation') {
      if (!user) return null;

      let evaluations;
      
      switch (type) {
        case 'autoevaluation':
          evaluations = user.autoevaluations;
          break;
        case 'third':
          evaluations = user.thirdsEvaluations;
          break;
        default:
          evaluations = user.managerEvaluations;
      }
      console.log('Compentencia', competency_id);
      console.log('type', type);
      if (!Array.isArray(evaluations) || evaluations.length === 0) {
        return null;
      }

      const evaluation = evaluations[0];
      if (!evaluation || !Array.isArray(evaluation.evalutionComments)) {
        return null;
      }

      const comment = evaluation.evalutionComments.find(comp => comp.competency_id === competency_id);
      console.log('comment', comment);
      return comment || null;
    },

    formatNumberDecimal(value) {
      return parseFloat(value).toFixed(2);
    },
    getAverageGoal(user) {
      if (!user.scopeEvaluations || user.scopeEvaluations.length === 0) {
        return 0;
      }

      const total = user.scopeEvaluations.reduce((sum, comp) => {
        const score = parseFloat(comp.real_progress_percentage);
        return sum + (isNaN(score) ? 0 : score);
      }, 0);

      const count = user.scopeEvaluations.length;
      return (total / count).toFixed(2); // Retorna con 2 decimales
    },
    getAverageOfCompetenciesScopeUser(user) {
      if (!user.scopeEvaluations || user.scopeEvaluations.length === 0) {
        return 0;
      }

      const total = user.scopeEvaluations.reduce((sum, comp) => {
        const score = parseFloat(comp.average_score);
        return sum + (isNaN(score) ? 0 : score);
      }, 0);

      const count = user.scopeEvaluations.length;
      return (total / count).toFixed(2); // Retorna con 2 decimales
    },
    getAverageProgressFromPlans(user) {
      if (
        !user ||
        !user.plansCompetencies ||
        user.plansCompetencies.length === 0 ||
        !user.plansCompetencies[0].competencies ||
        !user.lastPlanCompleted ||
        user.lastPlanCompleted.length === 0
      ) {
        return 0;
      }

      const responses = user.lastPlanCompleted[0].plan_individual_responses;
      const competencyIds = user.plansCompetencies[0].competencies.map(c => c.competency.id);

      const matchedPercentages = responses
        .filter(resp => competencyIds.includes(resp.plan_competency.competency_id))
        .map(resp => parseFloat(resp.progress_percentage))
        .filter(p => !isNaN(p));

      if (matchedPercentages.length === 0) {
        return 0;
      }

      const total = matchedPercentages.reduce((sum, p) => sum + p, 0);
      return (total / matchedPercentages.length).toFixed(2); // devuelve el promedio con 2 decimales
    },
    extractSpecialties() {
      // Extraer especialidades únicas
      const specialtiesSet = new Set();
      this.reports.forEach(report => {
        if (report.specialty !== undefined) {
          specialtiesSet.add(report.specialty);
        }
      });
      this.specialties = Array.from(specialtiesSet);
    },
    filterUsersBySpecialty() {
      // Filtrar usuarios según la especialidad seleccionada
      const report = this.reports.find(r => r.specialty === this.selectedSpecialty);
      this.filteredUsers = report ? report.users : [];
    },
     getStatusClass(length) {
      return length > 0 ? "status-completed" : "status-pending";
    },
    getStatusText(length) {
      return length > 0 ? "Completado" : "Pendiente";
    },
    openPlanModal(evaluationId, userId) { 
      this.currentEvaluationId = evaluationId;
      this.userId = userId;
      this.isModalPlanOpen = true;
    },
		closePlanModal() {
			this.isModalPlanOpen = false;
    },
    getCompetencyScore(user, typeEvation, competencyName) {
      // Asegurarnos de que el tipo de evaluación sea válido
      const validTypes = ['autoevaluations', 'managerEvaluations', 'thirdsEvaluations', 'averageEvaluations'];

      if (!validTypes.includes(typeEvation)) {
        return  0;
      }

      // Acceder a las evaluaciones del tipo especificado
      const evaluations = user[typeEvation];

      // Buscar la calificación de la competencia en las evaluaciones del tipo especificado
      for (let evaluation of evaluations) {
        const competency = evaluation.competency_scores.find(
          (score) => score.competency_name === competencyName
        );
        if (competency) {
          return competency.average_score;
        }
      }

      // Si no se encuentra la competencia, mostrar un mensaje
      return 0;
    },

    getAverageEvaluationScore(user, typeEvation) {
        const validTypes = ['autoevaluations', 'managerEvaluations', 'thirdsEvaluations', 'averageEvaluations'];

        if (!validTypes.includes(typeEvation)) {
          return 0;
        }

        const evaluations = user[typeEvation];
        let totalScore = 0;
        let totalCount = 0;

        for (let evaluation of evaluations) {
          for (let competency of evaluation.competency_scores) {
            if (typeof competency.average_score === 'number') {
              totalScore += competency.average_score;
              totalCount++;
            }
          }
        }

        return totalCount > 0 ? (totalScore / totalCount) : 0;
    },
    ...mapMutations({
      setHeaderTitle: "setHeaderTitle"
    })
  }
};
</script>

<style scoped>
.specialty-select-container {
  margin-bottom: 20px;
}

.specialty-label {
  display: block;
  margin-bottom: 8px;
  font-size: 16px;
  color: #333;
}

.custom-select {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.user-list {
  margin-top: 20px;
}

.user-title {
  font-size: 18px;
  margin-bottom: 15px;
}

.user-card {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f9f9f9;
}

.user-header {
  font-size: 16px;
  color: #0056b3;
  margin-bottom: 10px;
}

.evaluation-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 0.8rem;
}

.evaluation-table th,
.evaluation-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
  font-size: 0.9rem;

}

.evaluation-table th {
  background-color: #f2f2f2;
}

.status-completed {
  background-color: #28a745;
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
}

.status-pending {
  background-color: #ffc107;
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
}

.details-table table {
  margin-top: 10px;
  width: 100%;
  border-collapse: collapse;
}

.details-table th,
.details-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}
.td-baseline{
  vertical-align: baseline;
}
</style>